import Skeleton, { type SkeletonProps } from "./Skeleton";
export { Skeleton as default, Skeleton, SkeletonProps };